/**
 * Do not edit directly
 * Generated on Tue, 07 Feb 2023 13:10:43 GMT
 */

export default "PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUwMDAxIDExLjI1VjMuMDA5OThMNC4yMjAwMSA2LjI4OTk4TDMuNTIwMDEgNS41Nzk5OEw4LjAwMDAxIDEuMDk5OThMMTIuNDkgNS41Nzk5OEwxMS43OCA2LjI4OTk4TDguNTAwMDEgMy4wMDk5OFYxMS4yNUg3LjUwMDAxWk0xMy44IDEzLjlWMTAuMTJIMTQuOFYxNC45SDEuMjAwMDFWMTAuMTJIMi4yMDAwMVYxMy45SDEzLjhaIiBmaWxsPSJpbmhlcml0Ii8+";